import React, { useContext } from "react";
import { Stores, StoresContext } from "Globals/Stores";
import { UserDetails } from "./User/UserDetails";
import { PrivateRoute } from "Globals/Views/PrivateRoute";
import * as RouterUtil from "Utils/Routing";
import { StoresInstance } from "Globals/Stores";
import { AppUrls } from "AppUrls";
import { UsersList } from "./User/UsersList";
import { DarwinLayout } from "Globals/Views/Layouts/DarwinLayout";
import { ClientRoutes } from "./Client/ClientRoutes";

export const AdminRoutes: React.FC = () => {
    function getRootLayout() {
        return DarwinLayout;
    }
    const store = useContext<Stores>(StoresContext);
    return (
        <>
            <ClientRoutes />
            <PrivateRoute
                exact
                path={AppUrls.Client.Admin.User.Add}
                component={UsersList}
                isAllowed={() => {
                    return store.Domain.AccountStore.IsLoggedIn && RouterUtil.canViewAdminSettings(StoresInstance);
                }}
                layout={getRootLayout()}
            />
            <PrivateRoute
                exact
                path={AppUrls.Client.Admin.Root}
                component={UsersList}
                isAllowed={() => {
                    return store.Domain.AccountStore.IsLoggedIn && RouterUtil.canViewAdminSettings(StoresInstance);
                }}
                layout={getRootLayout()}
            />
            <PrivateRoute
                exact
                path={AppUrls.Client.Admin.User.List}
                component={UsersList}
                isAllowed={() => {
                    return store.Domain.AccountStore.IsLoggedIn && RouterUtil.canViewAdminSettings(StoresInstance);
                }}
                layout={getRootLayout()}
            />
            <PrivateRoute
                exact
                path={AppUrls.Client.Admin.User.Detail}
                component={UserDetails}
                isAllowed={() => {
                    return store.Domain.AccountStore.IsLoggedIn && RouterUtil.canViewAdminSettings(StoresInstance);
                }}
                layout={getRootLayout()}
            />
            <PrivateRoute
                exact
                path={AppUrls.Client.Admin.User.Edit}
                component={UsersList}
                isAllowed={() => {
                    return store.Domain.AccountStore.IsLoggedIn && RouterUtil.canViewAdminSettings(StoresInstance);
                }}
                layout={getRootLayout()}
            />
        </>
    );
};
